const day = 1000 * 3600 * 24

export default {
  namespaced: true,
  state: {
    skuImg: '',
    update: [],
    oemRecords: [],
    CombinedInfo: {},
    groupList: [],
    CloneCombinedInfo: {},
    isFirst: true,
    activeSku: ''
  },
  getters: {
    getSku (state: { isFirst: boolean, activeSku: string}): string {
      return state.activeSku
    }
  },
  mutations: {
    updated (state: any): void {
      state.update.forEach((fn: any) => fn())
    },
    useUpdate (state: any, update: any): void {
      state.update[0] = update
    },
    SET_IS_FIRST: (
      state: { isFirst: boolean },
      isFirst: boolean
    ): void => {
      state.isFirst = isFirst
    },
    SET_ACTIVE_SKU: (
      state: { activeSku: string },
      sku: string
    ): void => {
      state.activeSku = sku
    }
  },
  actions: {
    setSku (
      {
        commit
      }: { commit: any },
      sku: string
    ) {
      if (sku) {
        commit('SET_ACTIVE_SKU', sku)
        setTimeout(() => {
          commit('SET_ACTIVE_SKU', '')
        }, 4000)
      }
    }
  },
  local: {
    oemRecords: 3 * day,
    CombinedInfo: 3 * day,
    groupList: true,
    CloneCombinedInfo: true
  }
}

export const ProductTypes = [
  { label: '全部', value: '' },
  { label: '普通商品', value: 1 },
  { label: 'OEM商品', value: 2 },
  { label: '组合商品', value: 3 }
].fort()

export const isCombined = (v: any): boolean =>
  v.productType === ProductTypes[3].value

export const platIcon: any = {
  NAM: 'https://static-s.theckb.com/BusinessMarket/SEO/AM.png',
  AM: require('@/assets/image/logos/AM.png'),
  TB: require('@/assets/image/logos/TB.png'),
  TM: require('@/assets/image/logos/TM.png'),
  ckb: require('@/assets/image/logos/CKB.png'),
  YW: require('@/assets/image/logos/CKB.png'),
  PD: require('@/assets/image/logos/PD.png'),
  WS: 'https://static-s.theckb.com/BusinessMarket/Client/market/market_wsy_logo.svg',
  VC: 'https://static-s.theckb.com/BusinessMarket/Client/market/market_skw_logo.svg',
  AMT: 'https://static-s.theckb.com/BusinessMarket/icon/1688selected/goods-selected-logo-ja.png',
  choice: 'https://static-s.theckb.com/BusinessMarket/SEO/choice.png',
  KKK: require('@/assets/image/logos/flag-icon-ko.svg'),
  underline: require('@/assets/image/icon/icon_offline.png'),
  YS: 'https://static-s.theckb.com/BusinessMarket/SEO/ckb_choice_logo.png',
  XZ: 'https://static-s.theckb.com/BusinessMarket/SEO/ckb_choice_logo.png'
}
